import { TAILWIND_COLORS } from "#src/utils/common";
import { Tooltip } from "@lockerpm/design";
import type { ReactNode } from "react";

export const TableActionLabelV2 = ({
  icon,
  text,
  warning = false,
  disabled = false,
  tooltip,
}: {
  icon: ReactNode;
  text: string;
  warning?: boolean;
  disabled?: boolean;
  tooltip?: string | ReactNode;
}) => {
  const res = (
    <div
      className={`flex items-center gap-2 p-2 group bg-white hover:bg-gray-v2-50 ${warning ? "text-error-v2-700" : "text-gray-v2"} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
    >
      {icon}
      <span
        className={`text-md font-medium ${warning ? "text-error-v2-700" : "text-gray-v2-700 group-hover:text-gray-v2-800"}`}
      >
        {text}
      </span>
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip
        color={TAILWIND_COLORS["gray-v2-900"]}
        title={
          <p className="text-xs text-white font-semibold text-center">
            {tooltip}
          </p>
        }
      >
        {res}
      </Tooltip>
    );
  }

  return res;
};
